import { useState, useEffect, useRef } from 'react'

export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value)
      }, delay)

      return () => clearTimeout(handler)
    },
    [delay, value]
  )

  return debouncedValue
}

export const useDebounceImmediate = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value)
  const timeout = useRef()

  useEffect(() => {
    const callNow = !timeout.current
    timeout.current = setTimeout(() => {
      timeout.current = null
    }, delay)
    if (callNow) setDebouncedValue(value)

    return () => {
      clearTimeout(timeout.current)
    }
  }, [delay, value])

  return debouncedValue
}
